import React, { FC } from 'react';

import CombinedAnalytics from './CombinedAnalytics';

type ProductAnalyticsType = {
  actions: {
    identify: (props: any) => void;
    track: (name: string, props?: any, options?: any, callback?: any) => void;
    filterTrack: (actions: any) => void;
  };
  helpers: {
    View: (pathName: string) => String;
    SortKeyCheck: (SortKey: string) => String;
    selectedFilters: () => string[];
    clearCombinedAnalyticsFilterStore: () => void;
    metrics: {
      update: (data: any) => any;
      store: {};
    };
  };
  filterTrackingHelpers: {
    Engagement: {
      totalTimeSpent: (label: string, totalTimeSpent: any) => object;
      dateRegistered: (data: any) => object;
      activityWithEabNetwork: (data: any) => object;
      activityWithMyInstitution: (data: any) => object;
    };
    Demographics: {
      Geography: {
        usa: (data: any) => object;
        international: (data: any) => object;
      };
    };
    Listmembership: {
      listLabels: (lists: object[]) => string;
    };
    PropsectProfile: {
      termCheck: (value: string, status: boolean) => boolean;
    };
  };
};
// Create the analytics context
export const ProductAnalyticsContext = React.createContext<
  Partial<ProductAnalyticsType>
>({});
export const ProductAnalyticActions = {
  CombinedAnalytics,
};
export const ProductAnalyticsProvider = ProductAnalyticsContext.Provider;
interface Props {
  children: any;
}

export const ProductAnalytics: FC<Props> = (props: Props) => {
  const { children } = props;
  return (
    <ProductAnalyticsProvider value={CombinedAnalytics}>
      {children}
    </ProductAnalyticsProvider>
  );
};
try {
    // @ts-ignore
    ProductAnalytics.displayName = "ProductAnalytics";
    // @ts-ignore
    ProductAnalytics.__docgenInfo = { "description": "", "displayName": "ProductAnalytics", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/context/ProductAnalytics/ProductAnalytics.tsx#ProductAnalytics"] = { docgenInfo: ProductAnalytics.__docgenInfo, name: "ProductAnalytics", path: "src/shared/context/ProductAnalytics/ProductAnalytics.tsx#ProductAnalytics" };
}
catch (__react_docgen_typescript_loader_error) { }